let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8k5W1")).then(() => parcelRequire('42H7Z'));